import React, {useEffect, useMemo, useState} from 'react';
import {CSSTransition} from 'react-transition-group';
import './styles.css';
import BasicButton from '../../components/BasicButton';
import BasicSection from '../../components/BasicSection';
import FileLinkWithLock from '../../components/FileLinkWithLock';
import PanelContainer from '../../components/PanelContainer';
import {ANIMATION_TIMEOUT_APPEAR} from '../../constants/animation';
import ENDPOINT from '../../constants/endpoints';
import ROUTE from '../../constants/route';
import {UPGRADE_ACCOUNT_TYPE} from '../../constants/upgrade-account-types';
import {Permission} from '../../helpers/user';
import useApi from '../../hooks/useApi';
import PageLayout from '../../layouts/PageLayout';
import CandidateProfile from '../../scenes/CandidateProfile';
import ResponseErrorDialog from '../../scenes/Dialog/components/ResponseErrorDialog';
import UpgradeRecruiterAccount from '../../scenes/Dialog/components/UpgradeRecruiterAccount';
import Sidebar from '../../scenes/Sidebar';
import InBounds from '../../scenes/Sidebar/components/InBounds';

const Preparatory = props => {
  const {
    user,
    history,
    globalActions: { updateUserInboundsCount },
  } = props;
  const [files, setFiles] = useState();
  const { get } = useApi();

  const allowViewFiles = useMemo(
    () => Permission.isAllowedPreparatoryFiles(user.permissions),
    [user.permissions]
  );

  useEffect(() => {
    get(
      ENDPOINT.OTHER.PREPARATORY_FILES,
      {},
      {
        handleSuccess: data => setFiles(data.files),
        handleError: response => ResponseErrorDialog({ response }),
      }
    );
  }, []);

  const handleUnlockClick = () => {
    if (UPGRADE_ACCOUNT_TYPE.RECRUITER === user.accountUpgradeType) {
      UpgradeRecruiterAccount();
    } else {
      history.push(ROUTE.CANDIDATE_UPGRADE_PREMIUM, {
        returnUrl: window.location.pathname,
      });
    }
  };

  return (
    <PageLayout
      pageClass="preparatory-page"
      pageTitle="Preparatory"
      mainContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <CandidateProfile>
            <PanelContainer
              styles={{ marginBottom: '10px', paddingTop: '35px' }}
            >
              <BasicSection
                title="Preparatory"
              >
                <div className="preparatory-page__disclaimer">
                  {!allowViewFiles && (
                    <>
                      <p className="preparatory-page__text">
                        Unlocking preparation gives you access to all GoBuyside
                        materials and reports.
                      </p>
                      <p className="preparatory-page__text">
                        This includes all future materials and reports we
                        publish.
                      </p>
                    </>
                  )}

                  <div className="preparatory-page__content">
                    <div className="preparatory-page__title">Materials</div>
                    {files &&
                      files.material &&
                      files.material.map(file => (
                        <div
                          className="preparatory-page__file"
                          key={file.FileID}
                        >
                          <FileLinkWithLock
                            data={file}
                            ignoreLock={allowViewFiles}
                          />
                        </div>
                      ))}
                  </div>

                  <div className="preparatory-page__content">
                    <div className="preparatory-page__title">Reports</div>
                    {files &&
                      files.report &&
                      files.report.map(file => (
                        <div
                          className="preparatory-page__file"
                          key={file.FileID}
                        >
                          <FileLinkWithLock
                            data={file}
                            ignoreLock={allowViewFiles}
                          />
                        </div>
                      ))}
                  </div>

                  {!allowViewFiles && (
                    <div className="preparatory-page__controls">
                      <div className="preparatory-page__button">
                        <BasicButton
                          btnWidth={200}
                          btnHeight={40}
                          btnFontWeight={600}
                          btnText="Unlock Preparation"
                          btnArrow={false}
                          btnBg="#fff"
                          btnHoverBg="#f40"
                          controlFunc={handleUnlockClick}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </BasicSection>
            </PanelContainer>
          </CandidateProfile>
        </CSSTransition>
      }
      sidebarContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <Sidebar>
            <InBounds
              inboundsCount={user.inbounds}
              onInboundsUpdate={updateUserInboundsCount}
            />
          </Sidebar>
        </CSSTransition>
      }
    />
  );
};

export default Preparatory;
